import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deletePersonalVolumeSchema = z.object({
  volumeId: z.string(),
});

export const deletePersonalVolume = mutator({
  schema: deletePersonalVolumeSchema,
  resolve: {},
  permissions: {
    none: "a volume is deleted only when owned by ctx.userId",
  },
  fn: async ({ tx, ctx, args }) => {
    const [volume] = await tx.run(
      zql.personalVolumes.where("id", args.volumeId).where("userId", ctx.userId)
    );
    if (!volume) throw userFacingError("Volume not found");

    await tx.mutate.personalVolumes.delete({ id: args.volumeId });
  },
});
